import type { MarkupColor } from '@/shared/utils/charterMarkup';

export const COLOR_LABELS: Record<MarkupColor, string> = {
  accent: 'Акцент',
  danger: 'Опасность',
  info: 'Синий',
  muted: 'Приглушённый',
  strong: 'Белый',
};
